import React, { useState } from 'react';
import './Marketplace.css';

const SellerRating = ({ listingId, onRatingSubmitted }) => {
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!rating) {
      setError('Bitte wählen Sie eine Bewertung aus.');
      return;
    }
    
    setSubmitting(true);
    setError(null);
    
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Sie müssen angemeldet sein, um eine Bewertung abzugeben.');
      }
      
      const response = await fetch(`/api/marketplace/${listingId}/rate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ rating, comment })
      });
      
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Fehler beim Abgeben der Bewertung.');
      }
      
      setSuccess('Ihre Bewertung wurde erfolgreich übermittelt.');
      setRating(null);
      setComment('');
      
      if (onRatingSubmitted) {
        onRatingSubmitted();
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };
  
  return (
    <div className="seller-rating-container">
      <h3>Verkäufer bewerten</h3>
      
      {error && (
        <div className="rating-error-message">
          <span className="material-symbols-outlined">error</span>
          <p>{error}</p>
        </div>
      )}
      
      {success && (
        <div className="rating-success-message">
          <span className="material-symbols-outlined">check_circle</span>
          <p>{success}</p>
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="rating-form">
        <div className="rating-options">
          <button
            type="button"
            className={`rating-option top ${rating === 'TOP' ? 'selected' : ''}`}
            onClick={() => setRating('TOP')}
            disabled={submitting}
          >
            <span className="material-symbols-outlined">thumb_up</span>
            TOP
            <small>+5 Punkte</small>
          </button>
          
          <button
            type="button"
            className={`rating-option ok ${rating === 'OK' ? 'selected' : ''}`}
            onClick={() => setRating('OK')}
            disabled={submitting}
          >
            <span className="material-symbols-outlined">thumb_up_off</span>
            OK
            <small>+2 Punkte</small>
          </button>
          
          <button
            type="button"
            className={`rating-option negative ${rating === 'NEGATIVE' ? 'selected' : ''}`}
            onClick={() => setRating('NEGATIVE')}
            disabled={submitting}
          >
            <span className="material-symbols-outlined">thumb_down</span>
            NEGATIV
            <small>-2 Punkte</small>
          </button>
        </div>
        
        <div className="rating-comment">
          <label htmlFor="comment">Kommentar (optional):</label>
          <textarea
            id="comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Schreiben Sie einen kurzen Kommentar zu Ihrer Erfahrung..."
            disabled={submitting}
          />
        </div>
        
        <button 
          type="submit" 
          className="rating-submit-button" 
          disabled={!rating || submitting}
        >
          {submitting ? (
            <>
              <div className="loading-spinner small"></div>
              <span>Wird übermittelt...</span>
            </>
          ) : (
            <>
              <span className="material-symbols-outlined">send</span>
              Bewertung abschicken
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default SellerRating;